import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {ACTION_TYPES} from "../consts";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {SeeAllClickEvent} from "../models/see-all-click-event";

export class SeeAllButtonClickAnalyticsEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.onSeeAllClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = SeeAllClickEvent;
  }

  async action(params) {
    const screen: String = this.getScreen(params.currentLinkModel?.name);
    const sendParams = {
      ...params,
      screen: screen,
      sportTypeId: this.state.appState.context.sportType?.id,
    }
    const clickEvent: SeeAllClickEvent = new SeeAllClickEvent(sendParams);

    this.analyticsService.createEvent(clickEvent);
  }
}
